import { getDateTime } from '../getDateTime';
import { splitTime } from '../splitTime';

const startIsEmptyMessage = 'Начало периода не указано';
const endIsEmptyMessage = 'Конец периода не указан';
const endLessThanNow = 'Конец периода ранее текущего времени';
const endLessThanStart = 'Конец периода ранее начала';

export interface ValidateTimeRangeParams {
  date?: string;
  from?: string;
  to?: string;
  diffMs?: number;
  message?: string;
  timezoneOffset?: number;
  allowEndLessThanStart?: boolean;
}

export const validateTimeRange = ({
  date,
  from,
  to,
  diffMs = 0,
  timezoneOffset = 0,
  message,
  allowEndLessThanStart,
}: ValidateTimeRangeParams): string | undefined => {
  const now = getDateTime({ timezoneOffset });
  const resultDate = date ? new Date(date) : now;
  const [fromHours, fromMinutes] = splitTime(from);
  const [toHours, toMinutes] = splitTime(to);

  if (isNaN(fromHours) || isNaN(fromMinutes)) return startIsEmptyMessage;

  if (isNaN(toHours) || isNaN(toMinutes)) return endIsEmptyMessage;

  const fromDate = from
    ? getDateTime({
        date: resultDate,
        hours: fromHours,
        minutes: fromMinutes,
        seconds: 0,
        milliseconds: 0,
      })
    : undefined;
  const toDate = to
    ? getDateTime({
        date: resultDate,
        hours: toHours,
        minutes: toMinutes,
        seconds: 59,
        milliseconds: 999,
      })
    : undefined;

  if (!fromDate) return startIsEmptyMessage;

  if (!toDate) return endIsEmptyMessage;

  let diffBetweenStartAndEndMs = +toDate - +fromDate;
  if (diffBetweenStartAndEndMs < 0 && allowEndLessThanStart) {
    toDate.setDate(toDate.getDate() + 1);
    diffBetweenStartAndEndMs = +toDate - +fromDate;
  }

  if (diffBetweenStartAndEndMs < 0) return endLessThanStart;

  const diffBeetweenEndAndNowMs = +toDate - +now;
  if (diffBeetweenEndAndNowMs < 0) return endLessThanNow;

  if (diffBetweenStartAndEndMs < diffMs) return message;
};
